module.exports = __webpack_public_path__ + "img/2010 winteressen 030.adccf26f.jpg";